import {Injectable} from '@angular/core';

export enum FormGroupDisplayType {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export type FormGroupOrientationConfigType = {
  label: string;
  control: string;
}

@Injectable({
  providedIn: 'root'
})
export class FormGroupConfigService {
  orientation: FormGroupDisplayType = FormGroupDisplayType.Vertical;
  orientationConfig: FormGroupOrientationConfigType = {
    label: 'col-4', control: 'col-8'
  };
}


